import React from 'react';
import Article from './Article';
import Graf from './Graf';

export default function ContactUs() {
  return (
    <Article
      title="Contact Us"
      asideTitle="support hours"
      asideBody="9am - 2am PST Daily"
    >
      <Graf>
        Oh, hey. If you’re here, that means you’ve got something you want to
        talk about - great! Drop us a line over at{' '}
        <a href="mailto:support@saucey.com">support@saucey.com</a> or give us a
        ring at 213-204-9608. We’ll get back to you as soon as we can.
      </Graf>
    </Article>
  );
}
